import React, { Component, PropTypes } from "react";

import { getDefaultFormState } from "../../utils";
import SchemaField from "./SchemaField";


class ArrayField extends Component {
  static defaultProps = {
    uiSchema: {}
  };

  constructor(props) {
    super(props);
    const formData = Array.isArray(props.formData) ? props.formData : null;
    this.state = {items: formData || getDefaultFormState(props.schema) || []};
  }

  get itemTitle() {
    const {schema} = this.props;
    return schema.items.title || schema.items.description || "Item";
  }

  isItemRequired(itemsSchema) {
    return itemsSchema.type === "string" && itemsSchema.minLength > 0;
  }

  asyncSetState(state, options) {
    // ensure state is propagated to parent component when it's actually set
    this.setState(state, _ => this.props.onChange(this.state.items, options));
  }

  onAddClick(event) {
    event.preventDefault();
    const {items} = this.state;
    const {schema} = this.props;
    this.asyncSetState({
      items: items.concat(getDefaultFormState(schema.items))
    }, {validate: false});
  }

  onDropClick(index, event) {
    event.preventDefault();
    this.asyncSetState({
      items: this.state.items.filter((_, i) => i !== index)
    }, {validate: false});
  }

  onChange(index, value) {
    this.asyncSetState({
      items: this.state.items.map((item, i) => {
        return index === i ? value : item;
      })
    }, {validate: false});
  }

  render() {
    const {schema, uiSchema} = this.props;
    const {items} = this.state;
    return (
      <fieldset
        className={`field field-array field-array-of-${schema.items.type}`}>
        <legend>{schema.title}</legend>
        {schema.description ? <div>{schema.description}</div> : null}
        <div className="array-item-list">{
          items.map((item, index) => {
            return (
              <div key={index}>
                <SchemaField
                  schema={schema.items}
                  uiSchema={uiSchema.items}
                  formData={items[index]}
                  required={this.isItemRequired(schema.items)}
                  onChange={this.onChange.bind(this, index)} />
                <p className="array-item-remove">
                  <button type="button"
                    onClick={this.onDropClick.bind(this, index)}>-</button></p>
              </div>
            );
          })
        }</div>
        <p className="array-item-add">
          <button type="button" onClick={this.onAddClick.bind(this)}>+</button>
        </p>
      </fieldset>
    );
  }
}

if (process.env.NODE_ENV !== "production") {
  ArrayField.propTypes = {
    schema: PropTypes.object.isRequired,
    uiSchema: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    formData: PropTypes.array,
  };
}

export default ArrayField;



/** WEBPACK FOOTER **
 ** ./components/fields/ArrayField.js
 **/